import { VALIDATION_PATTERNS } from '../../../constants/validationPatterns';
import { BookingFormData } from '../../CreateBooking/interface/BookingFormInterface';

interface RequiredFieldProps {
  value: string,
  errorKey: string,
  t: (key: string) => string
}
const requiredField = ({ value, errorKey, t }: RequiredFieldProps): string => !value.trim() ? t(errorKey) : '';

const editModeConditionalRequired = ({ value, errorKey, t, isEditMode }: RequiredFieldProps & { isEditMode: boolean }) =>
  isEditMode ? '' : requiredField({ value, errorKey, t });


export const validateBookingFields = (
  formData: BookingFormData,
  t: (key: string) => string,
  isEditMode = false
) => {
  return {
    aeName: editModeConditionalRequired({
      value: formData.aeName,
      errorKey: 'ae-name-required-error',
      t,
      isEditMode
    }),
    amName: editModeConditionalRequired({
      value: formData.amName,
      errorKey: 'am-name-required-error',
      t,
      isEditMode
    }),
    category: editModeConditionalRequired({
      value: formData.category,
      errorKey: 'category-required-error',
      t,
      isEditMode
    }),
    typeOfPurchase: editModeConditionalRequired({
      value: formData.typeOfPurchase,
      errorKey: 'type-of-purchase-required-error',
      t,
      isEditMode
    }),

    org: requiredField({ value: formData.org, errorKey: 'org-required-error', t }),
    rodeoAdName: requiredField({
      value: formData.rodeoAdName,
      errorKey: 'rodeo-ad-name-required-error',
      t
    }),
    brand: requiredField({ value: formData.brand, errorKey: 'brand-required-error', t }),

    exactBillingValue: !formData.exactBillingValue
      ? t('exact-billing-value-required-error')
      : !VALIDATION_PATTERNS.NUMERIC.test(formData.exactBillingValue.toString())
        ? t('exact-billing-value-invalid-error')
        : '',

    sfOpportunityId: !formData.sfOpportunityId.trim()
      ? t('sf-opportunity-id-required-error')
      : formData.sfOpportunityId.trim().length !== 18
        ? t('sf-opportunity-id-invalid-length-error')
        : !VALIDATION_PATTERNS.SF_OPPORTUNITY_ID.test(
          formData.sfOpportunityId.trim()
        )
          ? t('sf-opportunity-id-invalid-format-error')
          : '',

    ro:
      formData.ro.trim() &&
        !VALIDATION_PATTERNS.RO_FORMAT.test(formData.ro.trim())
        ? t('ro-invalid-format-error')
        : '',
    brandConfirmation: '',
    commentsByPoc: '',
    creatives: '',
    gtmStatus: isEditMode
      ? requiredField({ value: formData.gtmStatus ?? '', errorKey: 'gtm-status-required-error', t })
      : '',
  };
};
